export default __webpack_public_path__ + "static/media/member5.24eb1821.jpg";